import Cancellation from './Cancellation';
export { default as cancellationReducer } from './reducers';

export default Cancellation;
